import { useMutation } from '@northladder/services';
import {
  ErrorEventsEnum,
  errorLogToRemoteUtil,
  IApiError,
} from '@northladder/utilities';

import { USER_ACCOUNTS_API } from '../userAccountsAPIClient';

/**
 * This is to track the change password mutation keys in react query cache.
 */
const MUT_USER_CHANGE_PASSWORD = 'user-change-password';

interface IUserChangePasswordOptions {
  onSuccessCallback: () => void;
}

/**
 * This performs a password change request. It takes the users old and the new
 * password.
 */
export const useUserPasswordChangeMutation = ({
  onSuccessCallback,
}: IUserChangePasswordOptions) => {
  const { mutate, isPending, error } = useMutation({
    mutationKey: [MUT_USER_CHANGE_PASSWORD],
    networkMode: 'always',
    retry: false,
    mutationFn: USER_ACCOUNTS_API.changePassword,
    onSuccess: onSuccessCallback,
    onError: (err: IApiError) => {
      errorLogToRemoteUtil({
        error,
        errorCode: ErrorEventsEnum.ERROR_IN_API_CALL,
        errorTitle: 'useUserPasswordChangeMutation Error',
        message: err.message,
      });

      return err;
    },
  });

  return {
    error,
    isPending,
    changePassword: mutate,
  };
};
